import { ReactNode } from 'react';

interface FilterGroup {
    title: string;
    children: ReactNode;
}

interface FilterSidebarProps {
    filterGroups?: FilterGroup[];
    children?: ReactNode;
    className?: string;
}

const FilterSidebar = ({
    filterGroups = [],
    children,
    className = ''
}: FilterSidebarProps) => {
    return (
        <div className={`flex flex-col h-full shadow-xl ${className}`} style={{ boxShadow: '-4px 0 8px rgba(0, 0, 0, 0.1)' }}>
            <div className="flex flex-col flex-1 p-3 space-y-4 min-h-0">
                {/* Filter Groups */}
                {filterGroups.map((group, index) => {
                    const isLast = index === filterGroups.length - 1;
                    return (
                        <div key={group.title} className={isLast ? "flex flex-col flex-1 min-h-0 border-t border-gray-200 dark:border-slate-700 pt-3" : "space-y-2"}>
                            {group.title && (
                                <h3 className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide px-3 mb-3">
                                    {group.title}
                                </h3>
                            )}
                            <div className={isLast ? "space-y-1 overflow-y-auto flex-1" : "space-y-1"}>
                                {group.children}
                            </div>
                        </div>
                    );
                })}

                {/* Custom children */}
                {children}
            </div>
        </div>
    );
};

export default FilterSidebar;
